import React from 'react';
import { PropTypes } from 'prop-types';
import { push, replace } from 'connected-react-router';
import { SimpleTooltip } from './tooltip';
import { NormalizeClassNameString, ObjectHasProperty } from './utils';

export class Link extends React.Component {

    shouldComponentUpdate(nextProps) {
        const props = this.props;

        const result = 
            (nextProps.disabled != props.disabled) || 
            (nextProps.dispatch != props.dispatch) || 
            (nextProps.className != props.className) ||
            (nextProps.children != props.children) ||
            (nextProps.to != props.to);
            
        return result;
    }

    render() {
        const props = {...this.props};
        const {to, children, dispatch, tooltip, replaceHistory} = props;
        const disabled = props.disabled || !Boolean(to);

        delete props.to;
        delete props.children;
        delete props.disabled;
        delete props.dispatch;
        delete props.replaceHistory;
        delete props.tooltip;
        
        props.className = props.className || '';
        props.onClick = Link.preventDefault;

        if (Boolean(disabled)) {
            props.className += ' disabled';
            // props.href = undefined;
            props.href = '#';
        }
        else {
            props.href = undefined;

            if (typeof to === 'function') {
                props.href = '#';
                props.onClick = e => {
                    e.preventDefault();
                    to(e);
                };
            }
            else {
                props.href = to;

                if (typeof dispatch === 'function') {
                    props.onClick = e => {
                        e.preventDefault();

                        if (Boolean(replaceHistory)) {
                            dispatch(replace(to));
                        }
                        else {
                            dispatch(push(to));
                        }
                    }
                }
                else if (!/^#$|^javascript\:/i.test(to)) {
                    delete props.onClick;
                }
                else {
                    props.href = '#';
                }
            }
        }

        props.className = NormalizeClassNameString(props.className) || null;

        if (!Boolean(props.href)) {
            delete props.target;
            delete props.download;
            delete props.rel;
            delete props.hreflang;
            delete props.type;
            delete props.ping;
            delete props.referrerpolicy;
        }

        if (Boolean(tooltip)) {
            if (ObjectHasProperty(tooltip, 'visible')) {
                tooltip.visible = Boolean(tooltip.visible) && !disabled;
            }
            else {
                tooltip.visible = !disabled;
            }

            return (
                <SimpleTooltip {...tooltip}>
                    <a {...props}>{children}</a>
                </SimpleTooltip>
            )
        }
        else {
            return <a {...props}>{children}</a>
        }
    }
}
Link.propTypes = {
    to: PropTypes.oneOfType([PropTypes.string, PropTypes.func]).isRequired,
    disabled: PropTypes.bool,
    className: PropTypes.string,
    dispatch: PropTypes.func,
    replaceHistory: PropTypes.bool,
    tooltip: PropTypes.object,
}
Link.defaultProps = {
    disabled: false,
    className: '',
    replaceHistory: false,
}
Link.void = () => {};
Link.stopPropagation = e => e.stopPropagation();
Link.preventDefault = e => e.preventDefault();
